const scheAction = [
    {name:"On", nType:1},
    {name:"Off", nType:2},
    {name:"Holiday", nType:3},
];

exports.scheAction =scheAction;